<template>
  <div class="seo-edit-container">
    <AModal
      v-model="showModal"
      :actions="modalActions"
      title="SEO Settings"
      size="lg"
      disable-portaling
    >
      <seo-field-edit
        v-model="seo"
      />
    </AModal>
  </div>
</template>

<script>
import applogger from '@applogger'

export default {
  name: 'seo-page-edit',
  asyncData({ store, route, router }) {
    applogger.debug('seo-page-edit asyncData starting')
    return store.dispatch('seo/load', { path: route.path })
      .then(_ => {
        applogger.debug('seo-page-edit asyncData complete')
      })
  },
  data() {
    return {
      showModal: true
    }
  },
  computed: {
    modalActions() {
      return [
        {
          label: 'Cancel',
          handler: this.close
        },
        {
          label: 'Save',
          handler: this.save
        }
      ]
    },
    seo: {
      get: function() {
        return this.$store.getters['seo/getSeoData'](this.$route.path)
      },
      set: function(value) {
        this.$store.commit('STORE_SEO_SETTINGS', value)
      }
    }
  },
  methods: {
    save() {
      const currentPath = this.seo.path
      const oldPath = this.seo.oldpath
      this.$seoSave(this.seo)
        .then(_ => {
          this.close()
          if (currentPath !== oldPath) {
            this.$router.push(currentPath)
          }
        })
    },
    close() {
      this.$toggleHeadEdit()
    }
  }
}
</script>

<style lang="scss">
.seo-edit-container {
  .custom-modal {
    .field-edit-container {
      .seo-field-edit {
        margin-bottom: 0;
        border: 0;
        padding: 1em 2em;
      }
    }
  }
}
</style>
